import { Commit, createStore } from "vuex";
import axios from "axios";
import { GardenBasicModel } from "@/model/GardenBasicModel";
import { GardenServiceModel } from "@/model/GardenServiceModel";
import { GardenQuestionModel } from "@/model/GardenQuestionModel";
import { GardenCaseModel } from "@/model/GardenCaseModel";
import { GardenMessageModel } from "@/model/GardenMessageModel";
import { auth } from "./authModule.js";
// import { number } from "yup";

interface ListProps<P> {
  [id: string]: P;
}

export interface GlobalDataProps {
  gardenBasicData: ListProps<GardenBasicModel>;
  gardenCaseData: ListProps<GardenCaseModel>;
  gardenServiceData: ListProps<GardenServiceModel>;
  gardenQuestionData: ListProps<GardenQuestionModel>;
  gardenMessageData: ListProps<GardenMessageModel>;
  loading: boolean;
}

const asyncAndCommit = async (
  url: string,
  mutationName: string,
  commit: Commit
) => {
  const { data } = await axios.get(url);
  commit(mutationName, data);
  return data;
};
export default createStore<GlobalDataProps>({
  state: {
    gardenBasicData: {},
    gardenServiceData: {},
    gardenCaseData: {},
    gardenQuestionData: {},
    gardenMessageData: {},
    loading: false,
  },

  mutations: {
    // Garden Data
    fetchGardenBasicData(state, rawData) {
      state.gardenBasicData = rawData.data;
    },
    fetchGardenServiceData(state, rawData) {
      state.gardenServiceData = rawData.data;
    },
    fetchGardenCaseData(state, rawData) {
      state.gardenCaseData = rawData.data;
    },
    fetchGardenQuestionData(state, rawData) {
      state.gardenQuestionData = rawData.data;
    },
    fetchGardenMessageData(state, rawData) {
      state.gardenMessageData = rawData.data;
    },

    setLoading(state, status) {
      state.loading = status;
    },
  },

  actions: {
    // Garden Data
    fetchGardenBasicData(context) {
      asyncAndCommit(
        "https://eadate.com/gardenInit/GardenBasic",
        "fetchGardenBasicData",
        this.commit
      );
    },
    fetchGardenServiceData(context) {
      asyncAndCommit(
        "https://eadate.com/gardenInit/GardenService",
        "fetchGardenServiceData",
        this.commit
      );
    },
    fetchGardenCaseData(context) {
      asyncAndCommit(
        "https://eadate.com/gardenInit/GardenCase",
        "fetchGardenCaseData",
        this.commit
      );
    },
    fetchGardenQuestionData(context) {
      asyncAndCommit(
        "https://eadate.com/gardenInit/GardenQuestion",
        "fetchGardenQuestionData",
        this.commit
      );
    },
    fetchGardenMessageData(context) {
      asyncAndCommit(
        "https://eadate.com/gardenInit/GardenMessage",
        "fetchGardenMessageData",
        this.commit
      );
    },
  },

  modules: {
    auth,
  },
});
